export const STORAGE_KEY = 'movie-list-vue'
export const BASE_URL = 'https://movie-list.alphacamp.io'
export const INDEX_URL = BASE_URL + '/api/v1/movies/'
export const POSTER_URL = BASE_URL + '/posters/'
